/**
 * Ícones da navegação inferior.
 *
 * Traço de 2px, mesma família visual dos ícones do `Alert`. O contorno engrossa
 * na aba ativa: forma, não só cor — quem tem daltonismo ou está no sol enxerga
 * a diferença de peso antes de enxergar a diferença de matiz.
 */

import type { ReactNode } from 'react';

export type TabName = 'today' | 'plan' | 'messages' | 'profile';

const PATHS: Record<TabName, ReactNode> = {
  // Um dia marcado no calendário
  today: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 10h18" />
      <path d="M8.5 14.5h3v3h-3z" />
    </>
  ),
  // Uma sequência de dias
  plan: (
    <>
      <path d="M4 6h4M4 12h4M4 18h4" />
      <path d="M11 6h9M11 12h9M11 18h9" />
    </>
  ),
  // Conversa
  messages: (
    <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.8-.8L3 21l1.9-5a8.4 8.4 0 0 1-.8-3.6 8.4 8.4 0 0 1 8.4-8.4h.5a8.4 8.4 0 0 1 8 8Z" />
  ),
  // Pessoa
  profile: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
    </>
  ),
};

export function TabIcon({ name, active }: { name: TabName; active: boolean }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={active ? 2.4 : 1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
